export const SEARCH_ROUTE = '/api/embedding/search';
export const AUTH_ROUTE = '/api/auth/token';
